module.exports = __webpack_public_path__ + "7877c0e367b2606cb508b416c97d6a42.json";


//////////////////
// WEBPACK FOOTER
// ./src/portal/i18n/de.json
// module id = 1148
// module chunks = 0